exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".NewQuestionComponent .v-message-custom{margin:8px 0;padding:0 12px}", ""]);

// exports
